module.exports = __webpack_public_path__ + "img/portfolio1-m@2.cd70ff9b.jpg";